<div class="container vertical-center d-grid animated fadeIn fast" appCapslockOn (capslockOn)="capslockOn = $event">
  <div class="jumbotron-fluid vertical-center row">
    <div class="frame frame-login-executive col-12 center-block">
      <div class="row">
        <img
          style="position: relative"
          class="center-block"
          src="assets/images/login/Frame.png"
        />
        <img
          style="position: absolute"
          class="logo-login"
          src="assets/images/login/logo-bf-vertical.png"
        />
      </div>
      <div class="row row-title text-center">
        <h3 class="title secondary"><strong>Login</strong> Banco</h3>
        <label class="label-datos primary">Datos</label>
        <div id="space-bar" class="space-bar center-block"></div>
        <app-alert *ngIf="error" [alert]="error"></app-alert>
        <app-alert
          *ngIf="capslockOn"
          [alert]="constants.alerts.capslock"
        ></app-alert>
        <app-alert
          *ngIf="
            helpers.invalidControl(executiveForm.get('ruc')) &&
            !executiveForm.get('ruc').errors.required
          "
          [alert]="constants.alerts.invalidRuc"
        ></app-alert>
      </div>

      <div class="login-form center-block">
        <app-loading *ngIf="loading"></app-loading>
        <form *ngIf="!loading" [formGroup]="executiveForm" [class.mt-10]="anyAlert()" appBlockCopyPaste>
          <div class="form-group" [class.has-error]="helpers.invalidControl(executiveForm.get('ruc'))"
          >
            <label for="ruc" class="label-form">RUC Empresa</label>
            <input
              type="text"
              formControlName="ruc"
              maxlength="11"
              class="form-control"
              mask="0*"
            />
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(executiveForm.get('ruc'))"
            >
              <span *ngIf="executiveForm.get('ruc').errors.required">{{
                constants.validations.required.message
              }}</span>
            </span>
          </div>
          <div class="form-group" [class.has-error]="helpers.invalidControl(executiveForm.get('user_company'))">
            <label for="user_company" class="label-form">Usuario</label>
            <input
              type="text"
              mask="0*"
              [patterns]="patternMail"
              suffix="@bancofalabella.com.pe"
              formControlName="user_company"
              class="form-control component-form"
              maxlength="52"
            />
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(executiveForm.get('user_company'))"
            >
              <span *ngIf="executiveForm.get('user_company').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span *ngIf="executiveForm.get('user_company').errors.minlength">{{
                constants.validations.loginExecutive.alphabetic.message
              }}</span>
              <span *ngIf="executiveForm.get('user_company').errors.pattern">{{
                constants.validations.alphabetic.message
              }}</span>
            </span>
          </div>

          <div class="form-group" [class.has-error]="helpers.invalidControl(executiveForm.get('password'))">
            <label for="password" class="label-form">Clave</label>
            <input
              type="password"
              formControlName="password"
              class="form-control component-form"
              maxlength="20"
            />
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(executiveForm.get('password'))"
            >
              <span *ngIf="executiveForm.get('password').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span *ngIf="executiveForm.get('password').errors.pattern">{{
                constants.validations.loginExecutive.alphanumeric.message
              }}</span>
            </span>
          </div>
          <div class="form-group">
            <button
              (click)="login()"
              [disabled]="executiveForm.invalid"
              class="button-continue center-block btn-block button-find-label"
            >
              Continuar
            </button>
          </div>
        </form>
        <div class="row text-center">
          <a *ngIf="!loading" [routerLink]="['/login/company']" class="secondary bottom-link"
            >Ir a Login Empresa</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
